<template>
  <MCAFinancingGridLayout>
    <section :class="$style['grid-item-a']">
      <h3 :class="$style['grid-header']">
        {{ $t('spendPage.spend') }}
      </h3>
      <MCAUseFundsFinancingPanel />
    </section>
    <section :class="$style['grid-item-b']">
      <h3 :class="$style['grid-header']">
        {{ $t('components.pageDashboard.advances') }}
      </h3>
      <MCAActiveAdvanceDetailsWithConditionalProgressBar
        v-for="a in validActiveAdvances"
        :key="a.id"
        :advance="a"
      />
    </section>
    <section :class="$style['grid-item-c']">
      <!-- <h4>{{ $t('spendPage.recentTransactions') }}</h4> -->
      <h3 :class="$style['grid-header']">
        {{ $t('spendPage.recentTransactions') }}
      </h3>
      <MCASpendTransactionsPreview />
      <div :class="$style['ui-button']">
        <UiButton
          size="small"
          :text="$t('spendPage.seeTransactions')"
          @click="seeAllTransactions"
        />
      </div>
    </section>
  </MCAFinancingGridLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import { useMeta } from 'vue-meta';
import { UiButton } from '@clearbanc/design-components/src/components';
import { RouteNames } from '@/data/routes';
import MCAUseFundsFinancingPanel from '@/pages/mca/components/MCAUseFundsFinancingPanel.vue';
import MCASpendTransactionsPreview from '@/pages/mca/components/MCASpendTransactionsPreview.vue';
import MCAActiveAdvanceDetailsWithConditionalProgressBar from '@/pages/mca/components/MCAActiveAdvanceDetailsWithConditionalProgressBar.vue';
import MCAFinancingGridLayout from '@/pages/mca/components/MCAFinancingGridLayout.vue';

export default {
  setup() {
    useMeta({
      title: 'Spend my funds | Clearco',
    });
  },
  components: {
    MCAUseFundsFinancingPanel,
    MCASpendTransactionsPreview,
    MCAFinancingGridLayout,
    UiButton,
    MCAActiveAdvanceDetailsWithConditionalProgressBar,
  },
  computed: {
    ...mapGetters(['activeAdvances', 'validActiveAdvances']),
  },
  async created() {
    await this.$store.dispatch('refreshAdvances');

    if (
      this.activeAdvances.length &&
      this.activeAdvances.every((a) => a.feesVersionId === 5)
    )
      this.$router.push(RouteNames.MCA.ADVANCES);
  },
  methods: {
    seeAllTransactions() {
      this.$router.push({ name: RouteNames.MCA.SPEND_TRANSACTIONS });
    },
  },
};
</script>

<style lang="less" module>
.grid-banner {
  grid-row-start: 1;
  grid-row-end: 2;
  grid-column-start: 1;
  grid-column-end: 13;
  padding-bottom: @spacing-16;

  span[class*='p-message-icon'] {
    margin-top: 5px;
  }
}

.grid-header {
  font-family: @regular-font;
}

.grid-item-a {
  grid-column-start: 1;
  grid-column-end: 5;
  grid-row-start: 3;
  grid-row-end: 4;
  margin-bottom: @spacing-32;
}

.grid-item-b {
  grid-column-start: 5;
  grid-column-end: 13;
  grid-row-start: 3;
  grid-row-end: 4;
  margin-bottom: @spacing-32;
  max-height: fit-content;
}

.grid-item-c {
  display: inline-grid;
  grid-gap: @spacing-16;
  grid-column-start: 1;
  grid-column-end: 13;
  grid-row-start: 5;
  grid-row-end: 6;
  margin-bottom: @spacing-24;
  overflow-x: auto;

  .ui-button {
    margin-right: auto;
    margin-left: auto;
  }
}

// tablet + mobile will have a stacked layout
@media only screen and (max-width: 1024px) {
  .grid-item-a {
    grid-column-end: 13;
  }

  .grid-item-b {
    grid-column-start: 1;
    grid-row-start: 4;
    grid-row-end: 5;
  }
}
</style>
